// PaymentMethodList.js
import React, { useEffect, useState } from "react"
import { Card, Button, Spinner, Alert } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import DataTable from "../../../components/DataTable/DataTable"
import paymentService from "../services/paymentMethodService"
import { Icon } from "../../../components"

export const PaymentMethodList = () => {
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let mounted = true
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const response = await paymentService.list()
        let data = []
        if (Array.isArray(response)) data = response
        else if (Array.isArray(response.results)) data = response.results
        else if (Array.isArray(response.data)) data = response.data
        else console.warn("Unexpected format from paymentService.list():", response)
        if (mounted) setRows(data)
      } catch (err) {
        console.error("Error loading payment methods", err)
        if (mounted) setError(`Error al cargar métodos de pago: ${err.message}`)
      } finally {
        if (mounted) setLoading(false)
      }
    })()
    return () => { mounted = false }
  }, [])

  const handleNew = () => navigate("/_payment_method/new")
  const handleEdit = id => navigate(`/_payment_method/edit/${id}`)
  const handleDelete = async id => {
    if (!window.confirm("¿Eliminar método de pago?")) return
    setLoading(true)
    try {
      await paymentService.remove(id)
      setRows(prev => prev.filter(r => r.id !== id))
    } catch (err) {
      console.error("Error deleting payment method", err)
      setError(`No se pudo eliminar: ${err.message}`)
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    { name: "ID", selector: r => r.id, sortable: true },
    { name: "Nombre", selector: r => r.name, sortable: true },
    { name: "Activo", selector: r => (r.active ? "Sí" : "No"), sortable: true },
    {
      name: "Acciones",
      cell: row => (
        <>
          <Button size="sm" variant="outline-primary" className="me-1" onClick={() => handleEdit(row.id)}>
            <Icon name="edit" />
          </Button>
          <Button size="sm" variant="outline-danger" onClick={() => handleDelete(row.id)}>
            <Icon name="trash" />
          </Button>
        </>
      ),
    }
  ]

  return (
    <Layout title="Métodos de Pago" content="container" loading={loading}>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Métodos de Pago</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
          <Button variant="primary" onClick={() => navigate("/_payment_method/new") }>
              <Icon name="plus" />
              <span> Nuevo método de pago</span>
            </Button>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card body>
          {error && <Alert variant="danger">{error}</Alert>}
          <DataTable
            data={rows}
            columns={columns}
            progressPending={loading}
            noDataComponent={<div>No hay métodos.</div>}
            pagination
            highlightOnHover
            searchByList={["name"]}
            className="data-table-head-light"
          />
        </Card>
      </Block>
    </Layout>
  )
}
export default PaymentMethodList
